import { SearchDriverOptions } from '@elastic/search-ui';
import { createRelatedJobsConnector } from '@scripts/frontend/elastic/proxy-connector';

export const relatedJobsConfig = (numberToShow: string, jobId: string): SearchDriverOptions => ({
  alwaysSearchOnInitialLoad: true,
  trackUrlState: false,
  initialState: {
    resultsPerPage: parseInt(numberToShow, 10),
  },
  searchQuery: {
    result_fields: {
      job_title: {
        raw: {},
      },
      job_description: {
        snippet: {},
      },
      location: {
        raw: {},
      },
      salary: {
        raw: {},
      },
      job_id: {
        raw: {},
      },
      posted_date: {
        raw: {},
      },
      offsite_preference: {
        raw: {},
      },
      friendly_salary: {
        raw: {},
      },
    },
  },
  apiConnector: createRelatedJobsConnector(jobId),
});
